// extracted by mini-css-extract-plugin
export var container = "_ub-0";
export var table = "_ub-2";
export var tableWrapper = "_ub-1";